import React from 'react';
import { motion } from 'framer-motion';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-tshirt',
      title: 'Ready to Wear',
      description: 'Stylish and trendy ready-made clothing for everyday fashion needs. Quality garments that fit perfectly.',
      image: '/p2.png'
    },
    {
      icon: 'fas fa-cut',
      title: 'Bespoke Tailoring',
      description: 'Custom-made clothing tailored to your exact measurements and style preferences. Unique pieces crafted just for you.',
      image: '/p3.png'
    },
    {
      icon: 'fas fa-ring',
      title: 'Bridal Wear',
      description: 'Exquisite wedding dresses and bridal accessories for your special day. Making your dream wedding look come true.',
      image: '/p6.png'
    },
    {
      icon: 'fas fa-users',
      title: 'Aseobi & Group Wear',
      description: 'Coordinated outfits for special occasions, parties, and group events. Beautiful matching designs for memorable celebrations.',
      image: '/p5.png'
    },
    {
      icon: 'fas fa-palette',
      title: 'Fashion Design',
      description: 'Creative fashion design services from concept to creation. Bringing your unique style vision to life.',
      image: '/p4.png'
    },
    {
      icon: 'fas fa-magic',
      title: 'Alterations & Repairs',
      description: 'Professional clothing alterations and repairs to ensure perfect fit and extend garment life.',
      image: '/p7.png'
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="section-header text-center mb-4">
          <h2>Fashion & Design Services</h2>
          <p>Comprehensive fashion solutions for all your clothing needs - from ready-to-wear to custom designs</p>
        </div>
        
        <div className="services-grid grid grid-3">
          {services.map((service, index) => (
            <motion.div 
              key={index} 
              className="service-card card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              whileHover={{ y: -10, scale: 1.02 }}
            >
              <div className="service-image">
                <img src={service.image} alt={service.title} />
                <div className="service-overlay">
                  <motion.div 
                    className="service-icon"
                    whileHover={{ scale: 1.2, rotate: 360 }}
                    transition={{ duration: 0.3 }}
                  >
                    <i className={service.icon}></i>
                  </motion.div>
                </div>
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;